/** 足行天下 API 数据映射 - 作者: zbq, 日期: 2026-05-29 */

import { DEFAULT_FORUM_INTRO, DEFAULT_FORUM_TITLE } from '@/sheep/constants/forum';

const DEFAULT_AVATAR = '/static/zvkf9s/fujia-logo.png';

function resolveAvatar(icon) {
  const raw = String(icon || '').trim();
  if (!raw || raw === 'null' || raw === 'undefined') return DEFAULT_AVATAR;
  return raw;
}

function formatTs(ts) {
  if (!ts) return '';
  const d = new Date(Number(ts) * 1000);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}

function footballStatus(item, tabStatus) {
  if (tabStatus === 'past') return '完场';
  if (tabStatus === 'live') return '进行中';
  const st = item?.status ?? item?.status_id;
  if (st === 'past' || st === 8 || st === '8') return '完场';
  if (st === 'live' || st === 3 || st === '3') return '进行中';
  return '未开始';
}

export function mapMember(data) {
  if (!data) return null;
  const balance = Number(data.userBalance ?? data.money ?? data.balance ?? 0);
  const rate = Number(data.tuiguangPercent ?? data.percent ?? 0);
  const dailishangID = String(data.dailishangID ?? data.dailishangId ?? '').trim();
  const id = data.id != null ? String(data.id) : '';
  const typeStr = String(data.type ?? '');
  // 结算商：无上级或上级指向自己；或后端已标记；或已配置推广分成
  const settlementSelf = !!id && (!dailishangID || dailishangID === id);
  const flagged = data.isMerchant === true || data.merchant === true
    || data.isMerchant === 1 || data.merchant === 1
    || data.isMerchant === 'true' || data.merchant === 'true';
  const isMerchant = flagged
    || (rate > 0 && (typeStr === '1' || Number(data.type) === 1))
    || (settlementSelf && (typeStr === '1' || Number(data.type) === 1) && rate > 0);
  return {
    id: data.id,
    nickname: data.nickname || '',
    avatar: resolveAvatar(data.icon),
    mobile: data.phone || '',
    balance,
    beans: balance,
    commissionRate: rate,
    remarks: data.remarks || '',
    role: isMerchant ? 'merchant' : 'user',
    isMerchant,
    isExpert: false,
    // 2026-10-26：平台管理员标记（后端 viewAll='1'）；首页据此显示「按专家切换」条，其它账号恒 false
    viewAll: data.viewAll === '1' || data.viewAll === 1 || data.viewAll === true,
    isAgent: isMerchant,
    dailishangID,
    inviteCode: data.inviteCode || data.id || '',
    tenantId: Number(data.tenantId ?? data.tenant_id ?? 0) || 0,
    followCount: 0,
    fansCount: Number(data.qty || 0),
    password: data.password || '',
    todayNum: Number(data.dayQty || 0),
    yesterdayNum: Number(data.yesterdayQty || 0),
    onLineNum: Number(data.dayQty || 0),
    dayMoney: Number(data.dayMoney || 0),
    yesterdayMoney: Number(data.yesterdayMoney || 0),
    sumMoney: Number(data.sumMoney || 0),
  };
}

export function mapArticle(item, options = {}) {
  if (!item) return null;
  const user = item.user || {};
  const tag = item.biaoqianVO?.[0] || {};
  const paid = item.pay === '1' || item.pay === 1 || options.forcePaid;
  return {
    id: item.id,
    articleId: item.id,
    expertId: item.expertId || item.expert?.id || '',
    merchantId: user.id || item.userId || item.uid,
    merchantName: user.nickname || item.nickname || '',
    merchantAvatar: user.icon || '/static/zvkf9s/avatar-default.png',
    schemeType: tag.title || item.lableName || '',
    title: item.title || '',
    expertIntro: item.expertIntro || user.expertIntro || '',
    summary: item.subTitle || '',
    price: Number(item.money || 0),
    priceBeans: Number(item.money || 0),
    drawNumbers: item.drawNumbers || '',
    originalPrice: Number(item.money || 0),
    tagId: tag.id || '',
    tagName: item.league || tag.title || '',
    leagueLogo: item.leagueLogo || '',
    matchId: item.matchId,
    matchNo: item.qishu || '',
    // 2026-10-31：期号原样保留。此前 mapArticle 只把它改名成 matchNo，
    // 而「方案管理」「一键开奖」按 a.qishu 取期号 → 永远取不到，只能退化为
    // 从标题正则抠「第N期」。商家标题自定义（如「12方案」）时期号彻底丢失，
    // 表现为开奖页「暂无期数」、方案管理没有期数筛选。
    qishu: item.qishu || '',
    matchName: item.team1 && item.team2 ? `${item.team1} vs ${item.team2}` : '',
    homeTeam: item.team1 || '',
    awayTeam: item.team2 || '',
    homeLogo: item.logo1 || '',
    awayLogo: item.logo2 || '',
    matchTime: item.matchTime || item.addTime || '',
    createTime: item.addTime || item.createTime || item.updateDate || item.matchTime || '',
    lianhong: Number(item.lianhong || 0),
    // 近三期战绩（2026-10-26）：后端 recentHits = [{qishu, win}]，真的最近 3 期、红黑如实
    recentHits: Array.isArray(item.recentHits)
      ? item.recentHits
          .filter((h) => h && typeof h.win === 'boolean')
          .slice(-3)
          .map((h) => ({
            qishu: String(h.qishu || '').trim(),
            win: !!h.win,
          }))
      : [],
    // 最佳连胜（红）：bestHits = 历史「连红最多」那一段（最多 7 条、全红）；bestStreak = 真实长度
    bestHits: Array.isArray(item.bestHits)
      ? item.bestHits
          .filter((h) => h && typeof h.win === 'boolean')
          .slice(0, 7)
          .map((h) => ({
            qishu: String(h.qishu || '').trim(),
            win: !!h.win,
          }))
      : [],
    bestStreak: Number(item.bestStreak || 0) || 0,
    readCount: Number(item.readQty || 0),
    buyCount: Number(item.qty || 0),
    isPaid: paid,
    hitResult:
      item.hitResult
      || (item.hit === '1' || item.hit === 1 || item.isWin === '1' ? 'win'
        : item.hit === '0' || item.isWin === '0' ? 'lose' : 'pending'),
    listed: item.fabu === '1' || item.fabu === 1,
    fabu: item.fabu != null ? String(item.fabu) : '1',
    hit: item.hit != null ? String(item.hit) : '',
    zhiding: item.zhiding === '1' || item.zhiding === 1 ? '1' : '0',
    pinned: item.zhiding === '1' || item.zhiding === 1,
    predict: item.score1 || item.predict || '',
    predictOdds: item.score2 || '',
    predictScores: (item.payContent || '').match(/\d+-\d+/g) || [],
    saleDeadline: item.dsTime ? new Date(String(item.dsTime).replace(/-/g, '/')).getTime() : 0,
    payContent: item.payContent || '',
    introContent: item.introContent || '',
    disclaimer: item.disclaimer || '',
    subTitle: item.subTitle || '',
    content: paid ? item.payContent || '' : '',
    fullContent: paid ? item.payContent || '' : '',
    gongkai: item.gongkai === '1' || item.gongkai === 1 ? '1' : '0',
    publicOpen: item.gongkai === '1' || item.gongkai === 1,
    // 2026-11-02：挂靠副本标记必须往下传，否则编辑页 isAffiliate 恒为 false，
    // 二级商家会看到「可编辑」表单、点保存才被后端拒绝（该方案由上级同步下发，不可修改）。
    // affiliateFlag=1 且 sourceArticleId 非空 = 副本；copyEditable=0 = 二级及以下的副本（只读）。
    affiliateFlag: Number(item.affiliateFlag || 0) === 1 ? 1 : 0,
    sourceArticleId: item.sourceArticleId || '',
    copyEditable: item.copyEditable != null ? String(item.copyEditable) : '1',
    // 2026-11-03：已售标记（后端 enrichPurchaseFlags 的 locked=1，含同家族副本成交）。
    // 此前没往下传，方案管理卡片无法区分「有客户买过」，商家也不知道为什么内容改不了。
    locked: item.locked != null ? String(item.locked) : '0',
    // 停盘（每日截止）后当期方案：详情/列表统一由服务端下发，卡片据此渲染「虚拟公开」角标
    saleStopped: item.saleStopped === '1' || item.saleStopped === 1 ? '1' : '0',
    saleStopTime: item.saleStopTime || '',
    status: 1,
  };
}

/** 可见付费正文：与后台 ZqConvert.shouldShowPayContent / contentOpen 对齐 */
export function resolveArticleAccess(data = {}) {
  const paid = data.pay === '1' || data.pay === 1;
  const articlePublic = data.gongkai === '1' || data.gongkai === 1;
  const price = Number(data.money || 0);
  // 已开奖/已日切：0=不中 1=中 2=往期标记；任一即结束「虚拟公开」加载中
  const hitRaw = data.hit != null && data.hit !== '' ? String(data.hit) : '';
  const hitRevealed = data.hitRevealed === '1' || data.hitRevealed === 1
    || hitRaw === '0' || hitRaw === '1' || hitRaw === '2';
  const purchased = data.purchased === '1' || data.purchased === 1;
  const ownerPreview = data.ownerPreview === '1' || data.ownerPreview === 1;
  // 详情可见性只信服务端 contentOpen（免费/公开/已购）。
  // 店主未公开时也不在详情免审展示（编辑页用字段 payContent 回填，不靠 canView）。
  const serverOpen = data.contentOpen === '1' || data.contentOpen === 1;
  const canView = serverOpen;
  // 售卖截止（每日如 21:20）：服务端已把needBuy 置 0；此处再兜一层，
  // 保证「已停售」能单独驱动文案，不依赖 needBuy 反推
  const saleStopped = data.saleStopped === '1' || data.saleStopped === 1;
  const saleStopTime = String(data.saleStopTime || '');
  // needBuy：优先服务端（店主未真下单仍要出购买按钮）；兼容旧包用本地推导
  let needBuy;
  if (data.needBuy === '1' || data.needBuy === 1) {
    needBuy = true;
  } else if (data.needBuy === '0' || data.needBuy === 0) {
    needBuy = false;
  } else {
    needBuy = price > 0 && !articlePublic && !purchased && !hitRevealed && !canView;
  }
  // 已停售一律不给购买入口
  if (saleStopped) needBuy = false;
  const waitingRelease = false;
  return {
    paid,
    purchased,
    ownerPreview,
    publicOpen: articlePublic,
    released: canView,
    price,
    canView,
    needBuy,
    waitingRelease,
    hitRevealed,
    saleStopped,
    saleStopTime,
  };
}

export function mapArticleDetail(data, uid) {
  const access = resolveArticleAccess(data);
  const article = mapArticle(data, { forcePaid: access.canView });
  if (!article) return null;
  article.content = access.canView ? data.payContent || '' : '';
  article.fullContent = access.canView ? data.payContent || '' : '';
  article.introContent = data.introContent || data.subTitle || '';
  article.disclaimer = data.disclaimer || '';
  article.isPaid = access.paid;
  article.canView = access.canView;
  article.needBuy = access.needBuy;
  article.purchased = access.purchased;
  article.ownerPreview = access.ownerPreview;
  article.waitingRelease = access.waitingRelease;
  article.publicOpen = access.publicOpen;
  article.saleStopped = access.saleStopped;
  article.saleStopTime = access.saleStopTime;
  article.hitRevealed = access.hitRevealed;
  article.payImages = data.payImages || [];
  article.images = data.images || [];
  article.subTitle = data.subTitle || '';
  article.expertIntro = data.expertIntro || data.user?.expertIntro || '';
  article.uid = uid;
  return article;
}

export function mapPastRecord(item) {
  // 往期正文只跟随后端 contentOpen/gongkai/已购下发的 payContent，不再假 forcePaid（否则空串当已解锁）
  const open =
    item.contentOpen === '1'
    || item.contentOpen === 1
    || item.gongkai === '1'
    || item.gongkai === 1
    || item.pay === '1'
    || item.pay === 1;
  const mapped = mapArticle(item, { forcePaid: open });
  if (!mapped) return null;
  const content = open
    ? String(item.payContent || mapped.fullContent || mapped.content || '').trim()
    : '';
  const scoreLines = content.match(/【\d+】[^【\n]+/g);
  const scoreFallback = [mapped.predict, mapped.predictOdds].filter(Boolean).join(' ');
  const predictScore = content.replace(/.*推荐[^:：]*[:：]?/g, '').trim() || scoreFallback;
  const hitRaw = item.hit != null ? String(item.hit) : mapped.hit != null ? String(mapped.hit) : '';
  let hitResult = '';
  if (hitRaw === '1' || item.isWin === '1' || mapped.hitResult === 'win') hitResult = 'win';
  else if (hitRaw === '0' || item.isWin === '0' || mapped.hitResult === 'lose') hitResult = 'lose';
  const drawNumbers = item.drawNumbers || mapped.drawNumbers || '';
  const drawNumberList = (() => {
    if (Array.isArray(drawNumbers) && drawNumbers.length) {
      return drawNumbers.map((x) => String(x).trim()).filter(Boolean);
    }
    return String(drawNumbers || '')
      .split(/[,，、\s]+/)
      .map((x) => x.trim())
      .filter(Boolean);
  })();
  return {
    id: mapped.id,
    title: mapped.title,
    // 往期卡的「已公开」角标读它（必须跟随后台公开开关，不能再用 hit 推断）
    gongkai: mapped.gongkai,
    publicOpen: mapped.publicOpen,
    subTitle: item.subTitle || mapped.subTitle || mapped.summary || '',
    content,
    payContent: content,
    fullContent: content,
    avatar: mapped.merchantAvatar,
    merchantAvatar: mapped.merchantAvatar,
    merchantName: mapped.merchantName,
    schemeType: mapped.schemeType ? `【${mapped.schemeType}】` : '',
    tagPrefix: '',
    matchNo: mapped.matchNo || item.qishu || '',
    league: mapped.tagName || '',
    homeTeam: mapped.homeTeam,
    awayTeam: mapped.awayTeam,
    homeLogo: mapped.homeLogo || '',
    awayLogo: mapped.awayLogo || '',
    predictTeam: mapped.predict || mapped.homeTeam,
    predictScore,
    scoreLines: scoreLines?.length ? scoreLines : scoreFallback ? [`【${mapped.matchNo || '1'}】 ${scoreFallback}`] : [],
    hit: hitRaw,
    hitResult,
    // 专家简介归专家区展示，不写入往期卡以免当成副标题重复刷屏
    expertIntro: '',
    drawNumbers,
    drawNumberList,
    createTime: mapped.createTime || item.addTime || item.matchTime || '',
    recentHits: mapped.recentHits || [],
    bestHits: mapped.bestHits || [],
    bestStreak: Number(mapped.bestStreak || 0) || 0,
  };
}

/** 解析期数（qishu / 标题「第N期」），用于往期倒序 */
export function periodNum(item) {
  if (!item) return 0;
  const raw = String(item.matchNo || item.qishu || item.period || '').trim();
  if (/^\d+$/.test(raw)) return Number(raw);
  const m = String(item.title || '').match(/第\s*(\d+)\s*期/);
  return m ? Number(m[1]) : 0;
}

/** 往期列表：期数倒序，同号再按发布时间倒序 */
export function sortPastByPeriodDesc(list) {
  const arr = Array.isArray(list) ? [...list] : [];
  return arr.sort((a, b) => {
    const d = periodNum(b) - periodNum(a);
    if (d !== 0) return d;
    return String(b.addTime || b.createTime || '').localeCompare(
      String(a.addTime || a.createTime || ''),
    );
  });
}

function pickTeamLabel(...values) {
  for (const v of values) {
    if (v != null && String(v).trim()) return String(v).trim();
  }
  return '';
}

function pickTeamLogo(...values) {
  for (const v of values) {
    if (v != null && String(v).trim()) return String(v).trim();
  }
  return '';
}

export function mapFootballMatch(item, tabStatus) {
  const teams = item?.teams || [];
  const home = teams.find((t) => t.side === 1) || teams[0] || {};
  const away = teams.find((t) => t.side === 2) || teams[1] || {};
  const homeInfo = home.team_info || home.teamInfo || {};
  const awayInfo = away.team_info || away.teamInfo || {};
  const homeScore = Array.isArray(home.score) ? Number(home.score[0] || 0) : 0;
  const awayScore = Array.isArray(away.score) ? Number(away.score[0] || 0) : 0;
  const league = item.league || {};
  const status = footballStatus(item, tabStatus);
  return {
    id: item.match_id || item.id,
    leagueName: league.abbr || league.name || '',
    leagueLogo: league.logo || '',
    homeTeam: pickTeamLabel(homeInfo.name, homeInfo.abbr, item.homeTeam, item.home_team),
    awayTeam: pickTeamLabel(awayInfo.name, awayInfo.abbr, item.awayTeam, item.away_team),
    homeLogo: pickTeamLogo(homeInfo.logo, item.homeLogo, item.home_logo, item.logo1),
    awayLogo: pickTeamLogo(awayInfo.logo, item.awayLogo, item.away_logo, item.logo2),
    matchTime: formatTs(item.start_time) || item.matchTime || '',
    status,
    homeScore,
    awayScore,
    articleCount: 0,
  };
}

export function mapMerchant(item) {
  if (!item) return null;
  const m = mapMember(item);
  const expertIntro = item.expertIntro || item.expert_intro || '';
  return {
    ...m,
    intro: expertIntro || item.remarks || '',
    expertIntro,
    fans: Number(item.qty || 0),
    articleCount: Number(item.articleQty || item.qty || 0),
    isFollow: item.attention === '1',
    level: item.type === '2' ? '金牌专家' : '专家',
  };
}

export function mapOrder(item) {
  if (!item) return null;
  const payTypeMap = {
    1: 'balance',
    3: 'wechat',
    5: 'alipay',
    微信: 'wechat',
    支付宝: 'alipay',
    余额: 'balance',
    豆余额: 'balance',
  };
  const payType = payTypeMap[item.payType] || payTypeMap[item.payTypeName] || item.payType || '';
  // 后端 status：0=待支付，1=已支付
  const paid = item.status === '1' || item.status === 1 || item.payStatus === '1';
  const status = paid ? 2 : 1;
  return {
    id: item.id,
    orderNo: item.orderNo || item.id,
    articleId: item.articleId || item.goodsId || item.id,
    articleTitle: item.title || item.articleTitle || '',
    merchantName: item.nickname || item.merchantName || item.userName || '',
    merchantAvatar: item.icon || item.userIcon || '/static/zvkf9s/avatar-default.png',
    buyerNickname: item.buyerNickname || '',
    buyerPhone: item.buyerPhone || '',
    matchName: item.matchName || (item.team1 && item.team2 ? `${item.team1} vs ${item.team2}` : ''),
    homeTeam: item.team1 || '',
    awayTeam: item.team2 || '',
    homeLogo: item.logo1 || '',
    awayLogo: item.logo2 || '',
    tagName: item.league || item.tagName || '',
    predict: item.score1 || item.predict || '',
    price: Number(item.money || item.price || 0),
    priceBeans: Number(item.money || item.price || 0),
    actualPay: Number(item.payMoney ?? item.actualPay ?? item.money ?? 0),
    status,
    statusText: status === 1 ? '待支付' : '已完成',
    payType,
    payTypeText:
      payType === 'alipay' ? '支付宝' : payType === 'wechat' ? '微信' : payType === 'balance' ? '余额' : payType === '0' ? '0元购' : '',
    payTime: item.payTime || item.updateDate || '',
    orderTime: item.addTime || item.createTime || '',
    createTime: item.addTime || item.createTime || '',
  };
}

export function mapTag(item) {
  return {
    id: item.id,
    name: item.title || item.name || '',
    title: item.title || item.name || '',
    sort: Number(item.sort ?? 0),
    status: item.status,
    bound: item.bound !== false && item.status !== 1 && item.status !== '1',
  };
}

export function mapBalanceDetail(item) {
  return {
    id: item.id,
    title: item.title || item.remark || item.typeName || '余额变动',
    amount: Number(item.money ?? item.amount ?? 0),
    balance: Number(item.balance ?? 0),
    createTime: item.addTime || item.createTime || '',
    type: item.type || '',
  };
}

export function mapWithdraw(item) {
  const status = Number(item.status ?? 0);
  const transferStatus = Number(item.transferStatus ?? 0);
  const statusText = status === 1 ? '已通过' : status === 2 ? '已拒绝' : '待审核';
  let extra = '';
  if (status === 1) {
    extra = ({ 0: '未打款', 1: '转账中', 2: '已到账', 3: '失败' }[transferStatus] || '');
  }
  return {
    id: item.id,
    money: Number(item.money ?? 0),
    feePercent: Number(item.feePercent ?? 0),
    feeAmount: Number(item.feeAmount ?? 0),
    actualAmount: Number(item.actualAmount ?? item.money ?? 0),
    account: item.account || '',
    accountType: Number(item.accountType ?? 1),
    realName: item.realName || '',
    status,
    transferStatus,
    transferErrorMsg: item.transferErrorMsg || '',
    statusText: extra ? `${statusText} · ${extra}` : statusText,
    auditRemark: item.auditRemark || '',
    createTime: item.addTime || item.createTime || '',
  };
}

/** 充值档位 */
export function mapRechargeTier(item) {
  return {
    id: item.id,
    beans: Number(item.beans ?? 0),
    price: Number(item.price ?? 0),
    sort: Number(item.sort ?? 0),
  };
}

export function mapChild(item) {
  return {
    id: item.id,
    nickname: item.nickname || item.phone?.slice(-4) || '用户',
    mobile: item.phone || '',
    avatar: item.icon || '/static/zvkf9s/avatar-default.png',
    joinTime: item.addTime || item.createTime || '',
    orderCount: Number(item.orderQty || item.qty || 0),
    commission: Number(item.money || item.commission || 0),
  };
}

export function mapForumFromMerchant(item, overrides = {}) {
  const intro = String(overrides.intro || '').trim();
  return {
    title: overrides.title || item?.nickname || DEFAULT_FORUM_TITLE,
    intro: intro || DEFAULT_FORUM_INTRO,
    onlineCount: Number(
      overrides.onlineCount ?? item?.onLineNum ?? item?.dayQty ?? item?.qty ?? 0,
    ),
  };
}

export function mapDisplayConfig(data = {}) {
  const showLianhong = data.showLianhong;
  const showTypePercent = data.showTypePercent;
  const showForum = data.showForum;
  const showNotice = data.showNotice;
  const toBool = (val) => !(val === '0' || val === 0 || val === false);
  return {
    showLianhong: toBool(showLianhong),
    showTypePercent: toBool(showTypePercent),
    showForum: toBool(showForum),
    showNotice: toBool(showNotice),
    forumTitle: data.forumTitle || '',
    forumIntro: data.forumIntro || '',
    forumOnlineCount: Number(data.forumOnlineCount) || 0,
  };
}

export function mapAgreement(item) {
  return {
    id: item.id,
    type: item.type || '',
    title: item.title,
    content: item.content,
  };
}

export function mapAbout(data) {
  if (!data) return {};
  return {
    logo: data.logo || '',
    name: data.companyName || '福家智库',
    companyName: data.companyName || '福家智库',
    phone: data.telephone || '',
    wechat: data.weixin || '',
    qq: data.qq || '',
    email: data.email || '',
    weibo: data.weibo || '',
    webUrl: data.url || '',
    content: data.content || '',
  };
}

export function mapPayResult(data, payType) {
  return {
    order: data,
    orderId: data?.id || data?.orderId || '',
    payType,
    body: data.body,
    payUrl: data.payUrl,
    pending: !!data.pending,
    merchantOrderNo: data.merchantOrderNo,
    payChannel: data.payChannel || '',
    jsapiParams: data.jsapiParams || null,
    alipaySchemeUrl: data.alipaySchemeUrl || '',
    msg: data.resultNote || (data.pending ? '请完成第三方支付' : '支付成功，完整内容已解锁'),
  };
}
